import { css } from '@emotion/css';
import { spacing } from '@prezzee/tokens';

import { Color } from 'css/theme';
import SelectItem from './SelectItem';
import { SortOption } from './index';
import { EMPTY_ELEMENT } from '../../../../common/utils/react';

const style = {
  list: (isDropdownOpen: boolean) => css`
    display: ${isDropdownOpen ? 'block' : 'none'};
    opacity: ${isDropdownOpen ? 1 : 0};
    min-width: 200px;
    position: absolute;
    right: 0;
    margin-top: ${spacing.spacing02};
    width: 100%;
    padding: 4px 1px;
    border-radius: 8px;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);
    transition: 0.3s;
    z-index: 999;
    background-color: ${Color.White};
    border: 1px solid #deddde;
  `,
};

type Props = {
  options: SortOption[];
  activeOption: SortOption;
  isDropdownOpen: boolean;
  onClose: () => void;
  setSortOption: (option: SortOption) => void;
};

const SelectList: React.FC<Props> = ({ options, isDropdownOpen, activeOption, onClose, setSortOption }) => {
  return (
    <ul className={style.list(isDropdownOpen)}>
      {options
        ? options.map((el, idx) => (
            <SelectItem
              key={idx}
              option={el}
              activeOption={activeOption}
              setSortOption={setSortOption}
              onClose={onClose}
            />
          ))
        : EMPTY_ELEMENT}
    </ul>
  );
};

export default SelectList;
